module.exports = __webpack_public_path__ + "img/Mail-Illustration.dcd268f1.svg";